import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FILE_EXTENSION_ICONS } from '@mdc/constants';

const FileTypeCell = ({ value }) => {
    const getIconForExt = (ext) => {
        const map = FILE_EXTENSION_ICONS;

        return map[ext] || map['gen'];
    };

    const classNames = classnames({
        'FileTypeCell': true,
        'icon': true,
    }, getIconForExt(value));

    return (<i className={classNames}></i>);
};

export default FileTypeCell;

FileTypeCell.propTypes = {
    value: PropTypes.string.isRequired
};
